/**
 *
 * Utility function to check if a phone number belongs to an organization
 * @param {String} org - Organization name, such as apple, google, or sxm
 * @param {Array} emergencyCalls - List of phone numbers objects to filter
 *   through the additionalData object
 * @param {String} callerID - Caller ID
 */
export const isCallerIDFromOrg = (org, emergencyCalls, callerID) => {
  if (org && emergencyCalls && callerID) {
    const additionalDataList = Object.keys(emergencyCalls).filter(num => {
      return Object.keys(emergencyCalls[num].additionalData).includes(org);
    });
    return additionalDataList.includes(callerID);
  }

  return false;
};
